var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-table__state" },
    [
      _vm.loading
        ? _c("mds-loader")
        : _c("mds-empty-state", {
            attrs: { title: _vm.title, message: _vm.description },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }